import { Text } from "@mantine/core";
import WarningCard from "@common/components/thirdParty/mantine/card/WarningCard";

interface Props {
  dataTestId: string;
}

export const SelfHostedWarning = ({ dataTestId }: Props) => {
  return (
    <WarningCard data-testid={dataTestId}>
      <Text fz="sm">
        <b>Storage</b> can&apos;t be added to a <b>self-hosted</b> subscription.
      </Text>
    </WarningCard>
  );
};
